// extracted by mini-css-extract-plugin
export default {"badge":"Sxq73iT006qXVZSkhO4k","circle":"GB2C3METCZgQWUO8IFwQ","info":"R0NWZ4S52Gx6P8KjUWrd","success":"mypTSdmgwmG53jVV2zM6","danger":"PQDvHvlmp2jOUNrberZW"};